import * as CL from '@design-system/component-library';

export const HighlightField = {
  CONTACT: 'contact',
  PURPOSE_OF_USE: 'purposeOfUse',
  COST_CENTER: 'costCenter',
  REFERENCE_ID: 'referenceId',
  NUMBER_PRIVACY_MOBILE: 'numberPrivacyMobile',
  NUMBER_PRIVACY_CORPORATE: 'numberPrivacyCorporate',
  CONTRACT_OWNER: 'contractOwner',
  BILLING_ACCOUNT: 'billingAccount',
} as const;

export type HighlightedField = (typeof HighlightField)[keyof typeof HighlightField];

interface HighlightedValueProps {
  highlighted: boolean;
  children: React.ReactNode;
}

export const HighlightedValue = ({ highlighted, children }: HighlightedValueProps) => (
  <div className="of-info-field__value">
    <span className={highlighted ? 'of-info-field__highlight of-info-field__highlight-text' : ''}>{children}</span>
    {highlighted && <CL.Icon color="warning" className="of-info-field__highlight" icon="check" />}
  </div>
);
